import { breakpoints } from '@americanexpress/dls/dist/6.22.1/vars/breakpoints.json';

export const previousSize = {
  size: '',
};

export default function getScreenSize(cb) {
  const devSizes = ['xs', 'sm', 'md', 'lg', 'xl']
    .map((label, index, breakOrder) => (
      {
        label,
        min: Number.parseInt(breakpoints[breakOrder[index]], 10) - 1,
        max:
          index < (breakOrder.length - 1)
            ? Number.parseInt(breakpoints[breakOrder[index + 1]], 10)
            : undefined
        ,
      }
    ));

  const screenSize = () => {
    let size = '';
    const width = Number.parseInt(window.innerWidth, 10);
    // eslint-disable-next-line no-restricted-syntax
    for (const sizeSet of devSizes) {
      if (sizeSet.min < width && (!sizeSet.max || sizeSet.max > width)) {
        size = sizeSet.label;
      }
    }
    return size;
  };

  const resize = () => {
    const size = screenSize();
    if (previousSize.size !== size) {
      previousSize.size = size;
      cb(size);
    }
  };

  if (cb && global.BROWSER) {
    window.addEventListener('resize', resize);
    previousSize.size = screenSize();
    cb(previousSize.size);
  }
}
